// extracted by mini-css-extract-plugin
module.exports = {"headerStyle":"_1UONl6EdMVAK6mCinOTo3-"};